/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PagesIndexRouteImport } from './routes/pages/index'
import { Route as PagesTermsOfServiceRouteImport } from './routes/pages/terms-of-service'
import { Route as PagesPrivacyPolicyRouteImport } from './routes/pages/privacy-policy'
import { Route as PagesHelpRouteImport } from './routes/pages/help'
import { Route as PagesContactRouteImport } from './routes/pages/contact'
import { Route as PagesAboutRouteImport } from './routes/pages/about'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesIndexRoute = PagesIndexRouteImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesTermsOfServiceRoute = PagesTermsOfServiceRouteImport.update({
  id: '/pages/terms-of-service',
  path: '/pages/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesPrivacyPolicyRoute = PagesPrivacyPolicyRouteImport.update({
  id: '/pages/privacy-policy',
  path: '/pages/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesHelpRoute = PagesHelpRouteImport.update({
  id: '/pages/help',
  path: '/pages/help',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesContactRoute = PagesContactRouteImport.update({
  id: '/pages/contact',
  path: '/pages/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesAboutRoute = PagesAboutRouteImport.update({
  id: '/pages/about',
  path: '/pages/about',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/pages/about': typeof PagesAboutRoute
  '/pages/contact': typeof PagesContactRoute
  '/pages/help': typeof PagesHelpRoute
  '/pages/privacy-policy': typeof PagesPrivacyPolicyRoute
  '/pages/terms-of-service': typeof PagesTermsOfServiceRoute
  '/pages': typeof PagesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/pages/about': typeof PagesAboutRoute
  '/pages/contact': typeof PagesContactRoute
  '/pages/help': typeof PagesHelpRoute
  '/pages/privacy-policy': typeof PagesPrivacyPolicyRoute
  '/pages/terms-of-service': typeof PagesTermsOfServiceRoute
  '/pages': typeof PagesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/pages/about': typeof PagesAboutRoute
  '/pages/contact': typeof PagesContactRoute
  '/pages/help': typeof PagesHelpRoute
  '/pages/privacy-policy': typeof PagesPrivacyPolicyRoute
  '/pages/terms-of-service': typeof PagesTermsOfServiceRoute
  '/pages/': typeof PagesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/pages/about'
    | '/pages/contact'
    | '/pages/help'
    | '/pages/privacy-policy'
    | '/pages/terms-of-service'
    | '/pages'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/pages/about'
    | '/pages/contact'
    | '/pages/help'
    | '/pages/privacy-policy'
    | '/pages/terms-of-service'
    | '/pages'
  id:
    | '__root__'
    | '/'
    | '/pages/about'
    | '/pages/contact'
    | '/pages/help'
    | '/pages/privacy-policy'
    | '/pages/terms-of-service'
    | '/pages/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PagesAboutRoute: typeof PagesAboutRoute
  PagesContactRoute: typeof PagesContactRoute
  PagesHelpRoute: typeof PagesHelpRoute
  PagesPrivacyPolicyRoute: typeof PagesPrivacyPolicyRoute
  PagesTermsOfServiceRoute: typeof PagesTermsOfServiceRoute
  PagesIndexRoute: typeof PagesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/': {
      id: '/pages/'
      path: '/pages'
      fullPath: '/pages'
      preLoaderRoute: typeof PagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/terms-of-service': {
      id: '/pages/terms-of-service'
      path: '/pages/terms-of-service'
      fullPath: '/pages/terms-of-service'
      preLoaderRoute: typeof PagesTermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/privacy-policy': {
      id: '/pages/privacy-policy'
      path: '/pages/privacy-policy'
      fullPath: '/pages/privacy-policy'
      preLoaderRoute: typeof PagesPrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/help': {
      id: '/pages/help'
      path: '/pages/help'
      fullPath: '/pages/help'
      preLoaderRoute: typeof PagesHelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/contact': {
      id: '/pages/contact'
      path: '/pages/contact'
      fullPath: '/pages/contact'
      preLoaderRoute: typeof PagesContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/about': {
      id: '/pages/about'
      path: '/pages/about'
      fullPath: '/pages/about'
      preLoaderRoute: typeof PagesAboutRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PagesAboutRoute: PagesAboutRoute,
  PagesContactRoute: PagesContactRoute,
  PagesHelpRoute: PagesHelpRoute,
  PagesPrivacyPolicyRoute: PagesPrivacyPolicyRoute,
  PagesTermsOfServiceRoute: PagesTermsOfServiceRoute,
  PagesIndexRoute: PagesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
